import { createContext } from 'react';

const LeaseDetailsContext = createContext();

export default LeaseDetailsContext;
